import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: false,
    user: null,
    clienteId: null,
    clienteInfo: null,
    sucursalId: null,
    sucursalInfo: null,
    sidenav: true,
    snackbar: { show: false, message: '', color: 'success' },
    waiting: { show: false, message: '' },
  },
  mutations: {
    setAuth(state, value) { state.auth = value; },
    setUser(state, value) { state.user = value; },
    setClienteId(state, value) { state.clienteId = value; },
    setClienteInfo(state, value) { state.clienteInfo = value; },
    setSucursalId(state, value) { state.sucursalId = value; },
    setSucursalInfo(state, value) { state.sucursalInfo = value; },
    setSidenav(state, value) { state.sidenav = value; },
    setSnackbar(state, value) { state.snackbar = { ...state.snackbar, ...value }; },
    setWaiting(state, value) { state.waiting = { ...state.waiting, ...value }; },
    logout(state) {
      state.auth = false;
      state.user = null;
      state.clienteId = null;
      state.clienteInfo = null;
      state.sucursalId = null;
      state.sucursalInfo = null;
    },
  },
  getters: {
    isAuth: (s) => s.auth,
    currentUser: (s) => s.user,
    clienteId: (s) => s.clienteId,
    clienteInfo: (s) => s.clienteInfo,
    sucursalId: (s) => s.sucursalId,
    sucursalInfo: (s) => s.sucursalInfo,
    isSidenavOpen: (s) => s.sidenav,
    currentRol: (s) => s.user?.rol || null,
    isSuperAdmin: (s) => s.user?.rol === 'SUPER_ADMIN',
    isAdminCliente: (s) => s.user?.rol === 'ADMIN_CLIENTE',
    isColaborador: (s) => s.user?.rol === 'COLABORADOR',
  },
});
